import RichTextArea from "../../forms/inputs/RichTextArea";
import EditorInput from "./EditorInput";

const EditorRichTextInput = ({
  inputTitle: title,
  name,
  details,
  required,
  disabled,
  minHeight,
  maxHeight
}: {
  inputTitle: string;
  name: string;
  details: string;
  required?: boolean;
  disabled?: boolean;
  minHeight?: string;
  maxHeight?: string;
}) => (
  <EditorInput
    name={name}
    inputTitle={title}
    details={details}
    required={required}
  >
    <div className={disabled ? "disabled" : ""}>
      <RichTextArea
        name={name}
        minHeight={minHeight}
        maxHeight={maxHeight}
        rules={{
          required: required
        }}
      />
    </div>
  </EditorInput>
);

export default EditorRichTextInput;
